import script from "./wodewangpan.vue?vue&type=script&setup=true&lang=js"
export * from "./wodewangpan.vue?vue&type=script&setup=true&lang=js"

import "./wodewangpan.vue?vue&type=style&index=0&id=0769cb72&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0769cb72"]])

export default __exports__